// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * TaskAssignedUserAttributes type.
 * @typedef {object} TaskAssignedUserAttributes
 * @property {string} id - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} taskId - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userAssignedById - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by TaskAssignedUserCreateAttributes.
 * @typedef {object} TaskAssignedUserCreateAttributes
 * @property {TaskAssignedUserAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 * @property {TaskAssignedUserAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by TaskAssignedUserUpdateAttributes.
 * @typedef {object} TaskAssignedUserUpdateAttributes
 * @property {TaskAssignedUserAttributes["taskId"] | null} [taskId] - Permitted taskId value.
 * @property {TaskAssignedUserAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for TaskAssignedUser.
 * @augments {FrontendModelBase<TaskAssignedUserAttributes, TaskAssignedUserCreateAttributes, TaskAssignedUserUpdateAttributes, TaskAssignedUserAttributes["id"], string>}
 */
class TaskAssignedUser extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "TaskAssignedUser",
      attributes: [
        "id",
        "createdAt",
        "taskId",
        "updatedAt",
        "userAssignedById",
        "userId",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      task: {type: "belongsTo"},
      user: {type: "belongsTo"},
      userAssignedBy: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      task: "Task",
      user: "User",
      userAssignedBy: "User",
    }
  }

  /** @returns {TaskAssignedUserAttributes["id"]} - Attribute value. */
  id() { return /** @type {TaskAssignedUserAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {TaskAssignedUserAttributes["id"] | null} newValue - New attribute value.
   * @returns {TaskAssignedUserAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {TaskAssignedUserAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {TaskAssignedUserAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {TaskAssignedUserAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {TaskAssignedUserAttributes["taskId"]} - Attribute value. */
  taskId() { return /** @type {TaskAssignedUserAttributes["taskId"]} */ (this.readAttribute("taskId")) }

  /**
   * @param {TaskAssignedUserAttributes["taskId"] | null} newValue - New attribute value.
   * @returns {TaskAssignedUserAttributes["taskId"] | null} - Assigned value.
   */
  setTaskId(newValue) { return /** @type {TaskAssignedUserAttributes["taskId"] | null} */ (this.setAttribute("taskId", newValue)) }

  /** @returns {TaskAssignedUserAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {TaskAssignedUserAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {TaskAssignedUserAttributes["userAssignedById"]} - Attribute value. */
  userAssignedById() { return /** @type {TaskAssignedUserAttributes["userAssignedById"]} */ (this.readAttribute("userAssignedById")) }

  /**
   * @param {TaskAssignedUserAttributes["userAssignedById"] | null} newValue - New attribute value.
   * @returns {TaskAssignedUserAttributes["userAssignedById"] | null} - Assigned value.
   */
  setUserAssignedById(newValue) { return /** @type {TaskAssignedUserAttributes["userAssignedById"] | null} */ (this.setAttribute("userAssignedById", newValue)) }

  /** @returns {TaskAssignedUserAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {TaskAssignedUserAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {TaskAssignedUserAttributes["userId"] | null} newValue - New attribute value.
   * @returns {TaskAssignedUserAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {TaskAssignedUserAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Returns task relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} - Relationship helper.
   */
  taskRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} */ (this.getRelationshipByName("task")) }

  /**
   * Returns task.
   * @returns {import("./task.js").Task | null} - Loaded related model.
   */
  task() { return this.taskRelationship().loaded() }

  /**
   * Builds task.
   * @param {import("./task.js").TaskCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./task.js").Task} - Built related model.
   */
  buildTask(attributes = {}) { return this.taskRelationship().build(attributes) }

  /**
   * Loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async loadTask() { return await this.taskRelationship().load() }

  /**
   * Returns or loads task.
   * @returns {Promise<import("./task.js").Task | null>} - Loaded related model.
   */
  async taskOrLoad() { return await this.taskRelationship().orLoad() }

  /**
   * Sets task.
   * @param {import("./task.js").Task | null} model - Related model.
   * @returns {void}
   */
  setTask(model) { this.taskRelationship().setLoaded(model) }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Returns userAssignedBy relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userAssignedByRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<TaskAssignedUser, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("userAssignedBy")) }

  /**
   * Returns userAssignedBy.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  userAssignedBy() { return this.userAssignedByRelationship().loaded() }

  /**
   * Builds userAssignedBy.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUserAssignedBy(attributes = {}) { return this.userAssignedByRelationship().build(attributes) }

  /**
   * Loads userAssignedBy.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUserAssignedBy() { return await this.userAssignedByRelationship().load() }

  /**
   * Returns or loads userAssignedBy.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userAssignedByOrLoad() { return await this.userAssignedByRelationship().orLoad() }

  /**
   * Sets userAssignedBy.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUserAssignedBy(model) { this.userAssignedByRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(TaskAssignedUser)

export {TaskAssignedUser}

export default TaskAssignedUser
